var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('survey-full')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }